import { ReactNode } from "react";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import { ListingGalleryImage } from "components/ListingImageGallery/utils/types";
import { useData } from "data/data-provider";

const DetailPagetLayout = ({
  children,
  showImgGallery,
  setShowImgGallery,
}: {
  children: ReactNode;
  showImgGallery: boolean;
  setShowImgGallery: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { selectedCar } = useData();

  const getImageGalleryListing = () => {
    return selectedCar?.fleet_photos?.map(
      (item, index): ListingGalleryImage => {
        return {
          id: index,
          url: item?.photo_url?.includes("http")
            ? item.photo_url
            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item?.photo_url}`,
        };
      }
    );
  };

  return (
    <div className="ListingDetailPage">
      <ListingImageGallery
        isShowModal={showImgGallery}
        onClose={() => setShowImgGallery(false)}
        images={getImageGalleryListing() ?? []}
      />

      <div className="container ListingDetailPage__content">{children}</div>
    </div>
  );
};

export default DetailPagetLayout;
